/* eslint-disable max-classes-per-file */
export class EntitiesList {
  constructor(mananger) {
    this.mananger = mananger;
    this.$q = this.mananger.$q;
    this.appAPI = this.mananger.appAPI;
    this.entitiesFormatter = this.mananger.entitiesFormatter;

    this.fetching = false;
    this.currentPage = 0;
    this.total = 0;
    this.searchQuery = '';
    this.items = [];
    this.done = false;
    this.itemsPerPage = 20;
  }
  reset() {
    this.currentPage = 0;
    this.total = 0;
    this.items = [];
    this.done = false;
    return this;
  }
  fetch(searchQuery = '', forceReset = false) {
    this.fetching = true;
    const shouldClean = this.searchQuery !== searchQuery || forceReset;
    const fetchingMore = (!shouldClean && this.items.length);

    let offset = 0;
    if (shouldClean) {
      this.reset();
      this.fetching = true;
    }

    this.currentPage += 1;
    offset = this.currentPage * this.itemsPerPage;
    this.searchQuery = searchQuery;
    const request = fetchingMore ?
      this.loadMoreItems(offset) :
      this.loadItems(offset);

    return request
    .then((response) => {
      const { items, total } = this.formatResponse(response);
      this.total = total;
      this.items.push(...items);
      this.done = (this.items.length >= this.total || items.length === 0);
      this.fetching = false;
      return items;
    })
    .catch((error) => {
      this.fetching = false;
      return this.$q.reject(error);
    });
  }
  loadItems() {
    throw new Error('The `loadItems` method hasn\'t been overwritten');
  }
  loadMoreItems() {
    throw new Error('The `loadMoreItems` method hasn\'t been overwritten');
  }
  formatResponse() {
    throw new Error('The `formatResponse` method hasn\'t been overwritten');
  }
}

export class EntitiesListsManager {
  constructor($q, appAPI, entitiesFormatter) {
    'ngInject';

    this.$q = $q;
    this.appAPI = appAPI;
    this.entitiesFormatter = entitiesFormatter;
  }
  newList() {
    const EntitiesListClass = this.getEntitiesListClass();
    return new EntitiesListClass(this);
  }
  getEntitiesListClass() {
    throw new Error('The `getEntitiesListClass` method hasn\'t been overwritten');
  }
}
